// src/components/Services.js
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const services = [
  {
    id: 1,
    name: "Banho e Tosa",
    description:
      "Oferecemos um serviço completo de banho e tosa, garantindo que seu pet esteja sempre limpo, saudável e bem cuidado.",
    img: "/assets/banho.jpg",
  },
  {
    id: 2,
    name: "Rações",
    description:
      "Disponibilizamos uma ampla variedade das melhores rações, adaptadas às necessidades nutricionais específicas de cada animal.",
    img: "/assets/2.jpeg",
  },
  {
    id: 3,
    name: "Acessórios",
    description:
      "Encontre brinquedos, camas e outros acessórios que proporcionam conforto e diversão para o seu pet.",
    img: "/assets/4.png",
  },
];

const Services = () => {
  return (
    <section className="service-section">
      <Container>
        <h2 className="text-center">Nossos Serviços</h2>
        <Row className="mt-4">
          {services.map((service) => (
            <Col md={4} className="mb-4" key={service.id}>
              <Card className="service-card">
                <div className="card-img-container">
                  <Card.Img variant="top" src={service.img} />
                </div>
                <Card.Body>
                  <Card.Title className="text-center">
                    {service.name}
                  </Card.Title>
                  <Card.Text>{service.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Services;
